/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { classNames } from '@ember-decorators/component';

@classNames('post-comment')
export default class PrintPostComment extends Component {
  // Services
  @service
  session;

  @service
  permissions;

  // Props
  // comment provides a comment resource.
  comment = null;

  // includeAuthorImages specifies whether to show authors' profile images.
  includeAuthorImages = true;

  // isRemoved checks to see if any content exists in the comment, therefore
  // marking it "removed" if it is an empty string.
  // TODO: implement proper backend support for comment deletion..?
  @computed('comment.content')
  get isRemoved() {
    return isEmpty(this.comment.content);
  }
}
